import { IconButton, Tooltip } from "@mui/material"
import { Undo } from "@mui/icons-material"
import { useEffect } from "react"
import UndoDeleteModal from "./UndoDeleteModal"
import { useSnackbar } from "notistack"
import { useDispatch, useSelector } from "react-redux"
import { clearFetchNoteError, clearSuccessMessage, clearUndoNoteError, fetchLastDeletedNote, selectDeletedNote, selectFetchUndoNoteError, selectIsModalOpen, selectSuccessMessage, selectUndoNoteError } from "../../../reducers/undoDeleteNoteSlice"
import {useWorkspaceContext} from "../../../pages/Dashboard"

export function UndoDeleteMenu() {
	const { workspaceId } = useWorkspaceContext()
	const isModalOpen = useSelector(selectIsModalOpen)
	const fetchUndoNoteError = useSelector((state) => selectFetchUndoNoteError(state, workspaceId))
	const undoNoteError = useSelector((state) => selectUndoNoteError(state, workspaceId))
	const successMessage = useSelector((state) => selectSuccessMessage(state, workspaceId))
	const deletedNote = useSelector((state) => selectDeletedNote(state, workspaceId))

	const dispatch = useDispatch()

	const { enqueueSnackbar } = useSnackbar()

	const handleClick = () => {
		dispatch(fetchLastDeletedNote(workspaceId))
	}

	useEffect(() => {
		let timer
		if(fetchUndoNoteError) {
			enqueueSnackbar(
				"There are no deleted notes to undo.", 
				{
					variant: "warning",
					autoHideDuration: 3000,
				}
			)
			timer = setTimeout(() => {
				dispatch(clearFetchNoteError(workspaceId))
			}, 3000)
		}

		return () => {
			if (timer) {
				clearTimeout(timer)
			}
		}
	}, [fetchUndoNoteError])

	useEffect(() => {
		let timer
		if (successMessage) {
			enqueueSnackbar(
				successMessage, 
				{
					variant: "success",
					autoHideDuration: 3000,
				}
			)
			timer = setTimeout(() => {
				dispatch(clearSuccessMessage(workspaceId))
			}, 3000)
		}

		return () => {
			if (timer) {
				clearTimeout(timer)
			}
		}
	}, [successMessage])

	useEffect(() => {
		let timer
		if(undoNoteError) {
			enqueueSnackbar(
				"There are no deleted notes to undo.", 
				{
					variant: "warning",
					autoHideDuration: 3000,
				}
			)
			timer = setTimeout(() => {
				dispatch(clearUndoNoteError())
			}, 3000)
		}

		return () => {
			if (timer) {
				clearTimeout(timer)
			}
		}
	}, [undoNoteError])

	return (
		<>
			<Tooltip title="Undo Last Delete">
				<IconButton
					onClick={handleClick}
					sx={{ p: "10px", flexGrow: 0 }}
					aria-label="collapse"
				>
					<Undo color={"action"} />
				</IconButton>
			</Tooltip>
		
			{ deletedNote && 
				<UndoDeleteModal open={isModalOpen} workspaceId={workspaceId} deletedNoteObject={deletedNote}></UndoDeleteModal>
			}
		</>
	)
}
